import PopupBox from "views/PopupBox";
import Vector2 from "lib/classes/vector2";

import $ from "jquery";

export interface PopupProps {
	title:Function, 
	render:Function,
	style?:Object,
	styleContainer?:Object,
	distinct?:boolean,
	closeable?:boolean,
	onClose?:Function,
	defaultPosition?:Vector2
}

const drawnPopups:Popup[] = [];

/**
	* Class for all popups
	* 
	* 
	* @param getTitle		-	Get title of the popup
	* @param getContent		-	Get content of the popup
	* @param style			-	Overriding styling for the popup window (optional)
	* @param closeable		-	Is the popup closeable? (optional)
*/
export class Popup {
	public id:number;
	public getTitle:Function;
	public getContent:Function;
	public onClose:Function;
	public style:Object;
	public styleContainer:Object;
	public distinct:boolean = false;
	public props:Map<any, any> = new Map<any, any>();
	public closeable:boolean = true;
	public showing:boolean = true;
	public dead:boolean = false;
	public lastDraw:number = 0;
	public defaultPosition:Vector2;
	
	constructor({title, render, style, styleContainer, closeable, onClose, defaultPosition, distinct}:PopupProps) {
		this.id = Math.floor(Math.random()*100000); // random id
		this.getTitle = title;
		this.getContent = render;
		this.style = style || {};
		this.styleContainer = styleContainer || {};
		this.distinct = distinct;
		this.closeable = closeable !== undefined ? closeable : this.closeable;
		this.onClose = onClose;
		this.defaultPosition = defaultPosition;
	}
	
	/**
		* Set custom popup property
		*
		* @param key	-	Property key
		* @param value	-	Property value
		*
		* @returns 
		* Properties map
	*/
	set(key:any, value:any):Map<any, any> {
		return this.props.set(key, value);
	}
	
	/**
		* Get custom popup property
		*
		* @param key	-	Property key
		*
		* @returns
		* Property value
	*/
	get(key:any):any {
		return this.props.get(key);
	}
	
	/**
		* Get the popup content element
		* 
		* @returns
		* jQuery element
	*/
	getViewport():any {
		return $(`#popup-content-${this.id}`);
	}
	
	/**
		* Set the popup drawn timestamp
	*/
	setTimeDrawn() {
		this.lastDraw = new Date().getTime();
	}
	
	/**
		* Close this popup
	*/
	public closeMe() {
		const res = this.onClose?.();
		
		if(res !== false)
			_ui.closePopupOf(this);
	}
}

/**
	* Draw popup
	*
	* @param popup			-	Popup instance
	* 
	* @return JSX for popup
*/
export function drawPopups(popups:Popup[]) {
	/* 
		- Old popups to disappear
		- Old old popups to be killed
	*/
	drawnPopups.forEach((popup:Popup) => {
		const index:number = popups.indexOf(popup);
		
		// Popup isn't present in new array and is already hidden: bin it
		if(!popup.showing && index < 0) {
			popup.dead = true;
			return;
		}
		
		let wasShowing:boolean = popup.showing;
		
		popup.dead = !popup.showing && index < 0;
		popup.showing = index > -1;
		
		if(popup.showing && !wasShowing)
			popup.setTimeDrawn();
	});
	
	// New popups to appear
	popups.forEach((popup:Popup) => {
		if(drawnPopups.indexOf(popup) < 0) {
			popup.setTimeDrawn();
			drawnPopups.push(popup);
		}
	});
	
	const toDraw:Popup[] = [...drawnPopups];
	const draws:any[] = [];
	
	toDraw.sort((x:Popup, y:Popup) => {
		if(x.lastDraw < y.lastDraw) return -1;
		if(x.lastDraw > y.lastDraw) return 1;
		return 0;
	});
	
	drawnPopups.forEach((popup:Popup) => {
		if(popup.dead) {
			draws.push(null);
			return;
		}
		
		draws.push(
			<PopupBox popup={popup} index={toDraw.indexOf(popup)} onClose={() => popup.closeMe()} key={draws.length} />
		)
	});
	
	return draws;
}